module.exports = "https://static.wmbcdn.com/uniweb/images/ff009ed980f50681d6a16f630097e5bb.svg";